exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".errorMessage {\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n  opacity: 0;\n  background-color: #FDECEA;\n  position: absolute;\n  top: 0;\n  z-index: -1;\n  width: 100%;\n}\n.errorMessage * {\n  display: inline-block;\n}\n.errorMessage .errorMessage-container {\n  width: calc(100% - 4rem);\n  padding: 2rem 2rem;\n}\n.errorMessage-visible {\n  opacity: 1;\n  z-index: 9999999999;\n}", ""]);

// exports
